module.exports = __webpack_public_path__ + "static/media/icon_device_off.7918cc1d.svg";